import { round } from "lodash-es";
import CountUp from "react-countup";
import "./style.scss";
import { HeaderAnalyticsProps } from "./types";

export function HeaderAnalytics({
  totalProgress,
  averageScore,
  topicScore,
  topicProgress,
  currentQuestion,
  totalQuestions,
  categoryName,
  topicName,
  isMarket = false,
}: HeaderAnalyticsProps) {
  return (
    <header className="tg_header">
      <div className="header-content tg_column">
        <div className={`progress-section ${isMarket ? "market" : ""}`}>
          <div className="progress-bar">
            <div
              className="progress-fill"
              style={{ width: `${totalProgress}%` }}
            ></div>
            {!isMarket && (
              <div
                className="progress-secondary"
                style={{
                  left: `${totalProgress}%`,
                  width: `${topicProgress}%`,
                }}
              ></div>
            )}
          </div>
        </div>

        <div className={`topic-info ${isMarket ? "market" : ""}`}>
          <span className="leadership-text">{categoryName}</span>
          {!isMarket && <span className="topic-label">{topicName}</span>}
          <span className="progress-counter">
            {currentQuestion} / {totalQuestions}
          </span>
        </div>

        <div className={`progress-section ${isMarket ? "market" : ""}`}>
          {!isMarket && (
            <div className="progress-stats">
              <div className="stat-item primary">
                <CountUp
                  end={round(averageScore, 0)}
                  preserveValue
                  suffix="%"
                />
              </div>
              <div className="stat-item secondary">
                <CountUp end={round(topicScore, 0)} preserveValue suffix="%" />
              </div>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}
